<template>
  <!-- 当有数据回显的时候，需要先awit枚举数据完成之后再回显 -->
  <div class="choose-pop">
    <van-popup v-model="visible" position="bottom">
      <div class="nd-choose-popup">
        <div class="nd-choose-toolbar">
          <span>{{ title || label }}</span>
          <img src="./images/close.png" @click="visible = false">
        </div>
        <div class="nd-choose-list" ref="list">
          <div class="nd-choose-item" :class="{ 'nd-choose-item_active': stashItem.value ===item.value, disabled: item.disable === 'Y' }" v-for="(item, index) in pickerData" :key="index" v-show="item.value !=='OTHER'" @click="selectItem(item)">
            {{ item.name }}
          </div>
        </div>
        <div class="extend-item" v-if="extend">
          <p class="name">其他</p>
          <nd-input  v-model="mExtendText" @focus="selectItem({value: 'OTHER'})" maxLength="20" label="" placeholder="请输入其他原因">
          </nd-input>
        </div>

        <div class="btn-box" v-if="extend">
          <nd-button @click="confirm">{{ confirmText }}</nd-button>
        </div>
        <div class="nd-choose-bottom"></div>
      </div>
    </van-popup>


  </div>
</template>
<script>
import { Popup } from 'vant'
export default {
  name: 'choose-pop',

  components: {
    'van-popup': Popup
  },

  data () {
    return {
      currentValue: this.value,
      selectItemIdx: -1,
      stashItem: {},
      mExtendText: ''
    }
  },

  props: {
    defaultValue: String,
    value: Boolean,
    label: String,
    data: Array,
    title: String,
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '完成'
    },
    valueKey: {
      type: Array,
      default: () => ['value', 'name']
    },
    extendText: String
 
  },

  created () {
    
  },
  watch: {
    defaultValue: {
      immediate: true,
      handler (val, oval) {
        if (val && !oval) {
          this.stashItem.value = val
          this.stashItem.name = val !== 'OTHER' ? this.pickerData.find(item => item.value === val).name : this.extendText
          this.$emit('change', this.stashItem)
        }
      }
    }
  },
  computed: {
    extend () {
      return this.pickerData.findIndex(item => item.value === 'OTHER') > -1
    },
    visible: {
      get () {
        if (this.value) {
          this.init()
        }
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    pickerData () {
      if (this.data && this.data.length > 0) {
        return this.data.map(item => {
          return {
            name: item[this.valueKey[1]],
            value: item[this.valueKey[0]],
            disable: item.disable
          }
        })
      }
      return []
    }
  },

  methods: {
    init () {
      if (this.defaultValue) {
        this.$nextTick(() => {
          if (this.extend) {
            this.selectItem({ value: this.defaultValue, name: this.extendText })
          } else {
            this.$set(this.stashItem, 'value', this.defaultValue)
          }
        })
      }
    },
  
    selectItem (item) {
      if (item.disable === 'Y') {
        return
      }
      this.stashItem = item
      
      if (item.value === 'OTHER') {
        this.mExtendText = item.name  
      } else {
        this.stashItem.name = this.pickerData.find(item => item.value === this.stashItem.value).name
      }
      if (!this.extend) {
        this.confirm()
      }
    },

    confirm () {
      if (this.stashItem.value === 'OTHER') {
        if (!this.mExtendText) {
          this.$message('请输入其他原因')
          return
        }
        this.stashItem.name = this.mExtendText
      }
      if (!this.stashItem.name) {
        this.$message('请选择原因')
        return
      }
      this.$emit('change', this.stashItem)
      this.visible = false
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.choose-pop {
  position: relative;
  height: 100%;
  width: 100%;

  .btn-box {
    margin-top: 60px ;
    text-align: center;
    .nd-button {
      margin: auto;
    }
  }
  .van-popup {
    border-radius: 30px 30px 0px 0px;
    overflow: hidden;

    .nd-choose-popup {
      .nd-choose-toolbar {
        height: 170px;
        box-sizing: border-box;
        padding: 65px 50px 55px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #EEEEEE;

        span {
          font-size: 36px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: @fc1;
        }

        img {
          width: 33px;
          height: 33px;
        }
      }

      .nd-choose-list {
        overflow: auto;
        max-height: 770px;

        .nd-choose-item {
          height: 110px;
          line-height: 110px;
          font-size: 30px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @fc1;
          padding: 0 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          border-bottom: 1px solid #EEEEEE;
          box-sizing: border-box;
          position: relative;
          &.disabled {
            color: #999;
          }

          &_active {
            &:after{
              background: url(./images/circle_01@2x.png) no-repeat ;
              background-size: 100% 100%;
              border:none !important
            }
           
          }
          &:after {
            content: "";
            width:34px;
            height:34px;
            border:1px solid #999;
            position: absolute;
            right: 40px;
            border-radius: 50%;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .nd-choose-bottom {
        height: 80px;
      }

      .extend-item {
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: @fc1;
        padding: 0 50px;
        padding-top: 30px;
        .nd-input{
          background: #FAFAFA;
          border-radius: 10px;
          border: 1px solid #EEEEEE;
          padding: 10px ;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>